var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#f39237",
    width: 800,
    height: 800,
    viewBox: "0 0 48 61",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.996 0C10.32 0 0 10.93 0 25.416c0 18.233 22.31 34.65 23.256 35.342.224.164.482.242.74.242s.516-.078.74-.242c.945-.693 23.255-17.109 23.255-35.342C48 10.93 37.68 0 23.996 0Zm0 38.128c-7.663 0-13.89-6.274-13.89-13.976 0-7.701 6.235-13.975 13.89-13.975 7.654 0 13.89 6.274 13.89 13.976 0 7.701-6.236 13.975-13.89 13.975Z"
  })));
};

export default SvgPin;